import { useState, useEffect, type KeyboardEvent } from 'react'

const COOKIE_CONSENT_KEY = 'pixorion_cookie_consent'
const COOKIE_CONSENT_MAX_AGE = 60 * 60 * 24 * 365

const hasConsentCookie = (): boolean => {
    return document.cookie.split('; ').some(cookie => cookie.startsWith(`${COOKIE_CONSENT_KEY}=`))
}

const setConsentCookie = (): void => {
    document.cookie = `${COOKIE_CONSENT_KEY}=accepted; max-age=${COOKIE_CONSENT_MAX_AGE}; path=/; SameSite=Lax`
}

export const CookieConsent = () => {
    const [isVisible, setIsVisible] = useState(false)

    useEffect(() => {
        if (!hasConsentCookie()) {
            setIsVisible(true)
        }
    }, [])

    const handleClose = () => {
        setConsentCookie()
        setIsVisible(false)
    }

    const handleCloseKeyDown = (event: KeyboardEvent<HTMLButtonElement>) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault()
            handleClose()
        }
    }

    if (!isVisible) {
        return null
    }

    return (
        <>
            <style>{`
        @keyframes cookie-consent-in { from { opacity: 0; transform: translateY(16px); } to { opacity: 1; transform: translateY(0); } }
        .cookie-consent-anchor { position: fixed; bottom: 24px; right: 100px; left: auto; width: min(420px, calc(100vw - 124px)); z-index: 9000; pointer-events: none; box-sizing: border-box; }
        .cookie-consent { width: 100%; pointer-events: auto; animation: cookie-consent-in 0.5s ease; }
        .cookie-consent-card { background: rgba(13,10,18,0.95); backdrop-filter: blur(20px); border: 1px solid rgba(118,65,226,0.3); border-radius: 14px; padding: 12px 40px 12px 14px; box-shadow: 0 8px 32px rgba(0,0,0,0.5); position: relative; }
        .cookie-consent-text { color: #b8b3bd; font-size: 13px; line-height: 1.4; margin: 0; }
        .cookie-consent-close { position: absolute; top: 50%; right: 10px; transform: translateY(-50%); width: 24px; height: 24px; border-radius: 999px; border: 1px solid rgba(255,255,255,0.2) !important; background: rgba(255,255,255,0.05) !important; color: #fff; padding: 0 !important; margin: 0; cursor: pointer; display: inline-flex; align-items: center; justify-content: center; line-height: 0; box-shadow: none !important; outline: none; transition: opacity 0.2s; }
        .cookie-consent-close:hover { opacity: 0.8; }
        .cookie-consent-close svg { display: block; width: 12px; height: 12px; flex-shrink: 0; }
        @media (max-width: 560px) { .cookie-consent-anchor { right: 100px; bottom: 16px; width: min(420px, calc(100vw - 116px)); } }
      `}</style>
            <div className='cookie-consent-anchor'>
                <div className='cookie-consent'>
                    <div className='cookie-consent-card'>
                        <p className='cookie-consent-text'>Для улучшения работы сайта мы используем файлы cookie</p>
                        <button
                            type='button'
                            className='cookie-consent-close'
                            onClick={handleClose}
                            onKeyDown={handleCloseKeyDown}
                            aria-label='Закрыть уведомление о cookie'
                        >
                            <svg
                                viewBox='0 0 12 12'
                                width='12'
                                height='12'
                                fill='none'
                                xmlns='http://www.w3.org/2000/svg'
                                aria-hidden='true'
                            >
                                <path
                                    d='M2.5 2.5l7 7M9.5 2.5l-7 7'
                                    stroke='currentColor'
                                    strokeWidth='1.5'
                                    strokeLinecap='round'
                                />
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
        </>
    )
}
